import Company from "./Company";
import HttpClient from "./HttpClient.js";

export default class User {
  constructor(user) {
    this.company = user.company ? new Company(user.company) : null;
    this.company_id = user.company_id;
    this.created_at = user.created_at;
    this.email = user.email;
    this.id = user.id;
    this.name = user.name;
    this.type = user.type;
    this.updated_at = user.updated_at;
  }

  static async loadUsers() {
    const client = new HttpClient();
    const userResponse = await client.instance.get("users");
    return userResponse.data;
  }

  static async loadMe() {
    const client = new HttpClient();
    const userResponse = await client.instance.get("user");
    return userResponse.data;
  }

  static async login(email, password) {
    const client = new HttpClient();
    try {
      const loginResponse = await client.instance.post("login", {
        email: email,
        password: password
      });
      return loginResponse;
    } catch (e) {
      return e.response;
    }
  }

  static async create(data){
    const client = new HttpClient();
    const userResponse = await client.instance.post(`users`, data);
    return userResponse.data;
  }

  async save(data){
    const client = new HttpClient();
    const userResponse = await client.instance.put(`users/${this.id}`, data);
    return userResponse.data;
  }

  async delete(){
    const client = new HttpClient();
    const userResponse = await client.instance.delete(`users/${this.id}`);
    return userResponse.data;
  }

  hasRights(code) {
    if (this.type == 0) {
      return true;
    }
    const right = this.company.system_rights.find(e => {
      return e.code == code;
    });
    if (right == null) {
      return false;
    }
    const column = this.getColumnFromUserType(this.type);
    return right[column];
  }

  getColumnFromUserType(userType) {
    let type = "worker";
    switch (userType) {
      case 1:
        type = "administrator";
        break;
      case 2:
        type = "planner";
        break;
      case 3:
        type = "manager";
        break;
      case 4:
        type = "packer";
        break;
      case 5:
        type = "worker";
    }
    return type;
  }
}
